import {valuableCardValue} from '@kapitalist/contract/ruleset'
import type {
  TStandardPropertyCardData,
  TStandardPropertyCard,
} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import PropertyCard from '~/models/game/Cards/PropertyCard'

export default class StandardPropertyCard extends PropertyCard<TStandardPropertyCardData> {
  public value: TMillions

  constructor(data: TStandardPropertyCardData) {
    super(data)
    this.value = valuableCardValue[data.type]
  }

  public fileName(): string {
    return `prop_${this.type}${this.version}`
  }

  public cardTypes(): Set<TStandardPropertyCard> {
    return new Set([this.type])
  }
}
